import { Reveal } from "../motion/Reveal";
import { ACADEMY_BG_IMG } from "../../data/academyData";

const marqueeItems = ["NO SHAME", "NO TABOO", "NO MISINFORMATION", "SCIENCE-BACKED", "JUDGMENT-FREE", "100% CONFIDENTIAL"];

export const AcademyIntro = () => (
  <section id="academy" data-testid="academy-intro-section" className="relative py-20 md:py-32 border-y border-white/10 overflow-hidden">
    <div className="absolute inset-0 -z-10">
      <img src={ACADEMY_BG_IMG} alt="Moody premium red-lit interior atmosphere" className="w-full h-full object-cover opacity-[0.15]" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#08080A] via-[#08080A]/85 to-[#08080A]" />
    </div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold mb-4">Welcome To AX Academy</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-5xl font-semibold text-white max-w-3xl leading-tight">
          India's leading intimacy & sexual wellness academy.
        </h2>
        <p className="mt-6 text-zinc-400 text-lg max-w-2xl leading-relaxed">
          A private, judgment-free space where Indian adults access world-class education on sex, relationships, performance & love. Just honest, science-backed, life-changing knowledge — delivered by a qualified expert who genuinely cares about your growth.
        </p>
      </Reveal>
    </div>

    <div className="mt-16 relative border-t border-b border-white/10 py-7 overflow-hidden whitespace-nowrap marquee-fade">
      <div className="marquee-track flex items-center gap-0 cursor-default">
        {[...marqueeItems, ...marqueeItems].map((item, i) => (
          <span key={i} className="inline-flex items-center gap-3 shrink-0 px-7">
            <span className="h-1.5 w-1.5 rounded-full bg-gradient-to-r from-rose-500 to-amber-400" />
            <span className="text-xl sm:text-2xl font-heading font-semibold tracking-wide text-white/20 hover:text-white/40 transition-colors">
              {item}
            </span>
          </span>
        ))}
      </div>
    </div>
  </section>
);
